import React from 'react';
import { Visitor } from 'types/Visitor';
import { getStateFromValue } from 'assets/data/countriesAndStates';
import EditIcon from 'assets/icons/edit.svg?react';
import { getFormattedDateAndTime } from 'utils/helpers';
import IconButton from 'components/Button/IconButton';

type VisitorCardAndFormProps = {
    editVisitor: (visitor: Visitor) => void;
    visitor: Visitor;
    timeZone: string;
};

function VisitorCardAndForm(props: VisitorCardAndFormProps) {
    const { visitor, editVisitor, timeZone } = props;
    const car = visitor.car_details || null;
    const state = car?.state ? getStateFromValue(car?.state, car?.country) : '';

    const validationSource = visitor.validation_source?.replace('-', ' ');
    const validUntil = visitor.visitor_sessions[0] ? visitor.visitor_sessions[0].end_datetime : visitor.valid_until;
    const validUntilDate = new Date(Number(validUntil) * 1000);

    return (
        <tr key={visitor.pk}>
            <td>
                {car.plate}
                {state && ` - ${state.value}`}
            </td>
            <td>{visitor.name}</td>
            <td>{visitor.validity_reason}</td>
            <td style={{ textTransform: 'capitalize' }}>{validationSource}</td>
            <td>{visitor.is_always_valid ? 'Always Valid' : getFormattedDateAndTime(validUntilDate, timeZone)}</td>
            <td>
                <IconButton onClick={() => editVisitor(visitor)}>
                    <EditIcon data-testid={`edit-${visitor.pk}`} fill="#808080" />
                </IconButton>
            </td>
        </tr>
    );
}

export default VisitorCardAndForm;
